<template>
    <div class="main">
        <el-main style="padding-left: 0px;">
            <!-- 路由占位符 -->
            <router-view></router-view>
        </el-main>
    </div>
</template>
<script>
export default {
    data(){
        return {

        }
    },
    created() {

    },
    methods:{

    }
}
</script>
<style scoped>
  /* 主区域 */
.main {
    /* width: 1000px; */
    position: absolute;
    top: 45px;
    left: 120px;
    bottom: 0px;
    right: 0px;  /* 距离右边0像素 */
    overflow-y: auto; /* 当内容过多时y轴出现滚动条 */
    background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/view/layout/Main.vue